module.exports = __webpack_public_path__ + "static/media/card-content-quiz.6e80fd6b.svg";